module.exports = __webpack_public_path__ + "static/media/shape1.e1ef127f.svg";